import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, message, DatePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import ContactLabelAddUpdateTable from "./ContactLabelAddUpdateTable";
import ContactLabelAddUpdateDrawer from "./ContactLabelAddUpdateDrawer";
import { getSowAbbrDetails } from "services/redux/officeresource/sowabbr/action"; // Correct import
import moment from "moment";

const SowAbbrAddUpdate = () => {
  const dispatch = useDispatch();

  // State for managing drawer visibility and data
  const [addUpdateDrawerVisibility, setAddUpdateDrawerVisibility] =
    useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Function to show the drawer for adding/updating sowAbbr
  const showAddUpdateDrawer = (record) => {
    if (record) {
      setSelectedRecord(record); // Set the record data for editing
      setIsUpdateMode(true); // Enable update mode
    } else {
      setSelectedRecord(null); // Reset for adding a new record
      setIsUpdateMode(false); // Disable update mode
    }
    setAddUpdateDrawerVisibility(true); // Open the drawer
  };

  // Function to close the drawer
  const onAddUpdateDrawerClose = () => {
    setAddUpdateDrawerVisibility(false);
    setSelectedRecord(null); // Reset the selected record
    setIsUpdateMode(false); // Reset update mode
  };

  return (
    <div className="layout">
      <div className="organizer sowAbbr">
        <div className="global-header-wrapper">
          <div className="header-info">
            <h3 className="header__all">Sow Abbreviations</h3>
          </div>
          <div className="header-action-wrapper">
            {/* Button to add a new sowAbbr */}
            <Button
              style={{
                backgroundColor: "#28a745", // Green color
                color: "white",
                border: "none",
                display: "inline-flex",
                alignItems: "center",
              }}
              onClick={() => showAddUpdateDrawer()} // Open drawer in add mode
            >
              <PlusOutlined /> New SowAbbr
            </Button>
          </div>
        </div>

        {/* Table component */}
        <ContactLabelAddUpdateTable
          showAddUpdateCountryDrawer={showAddUpdateDrawer} // Pass the drawer handler
          startDate={startDate}
          endDate={endDate}
        />

        {/* Drawer component for adding/updating sowAbbr */}
        <ContactLabelAddUpdateDrawer
          drawerVisibility={addUpdateDrawerVisibility}
          onAddUpdateCountryClose={onAddUpdateDrawerClose}
          isUpdateCountry={isUpdateMode}
          selectedRecord={selectedRecord} // Pass the selected record for editing
        />
      </div>
    </div>
  );
};

export default SowAbbrAddUpdate;
